/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectItemCommand } from '../../models/delete-project-item-command';
import { DeleteProjectitemCommandResult } from '../../models/delete-projectitem-command-result';

export interface ApiProjectItemDeleteProjectItemDelete$Plain$Params {
      body?: DeleteProjectItemCommand
}

export function apiProjectItemDeleteProjectItemDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemDeleteProjectItemDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectitemCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemDeleteProjectItemDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectitemCommandResult>;
    })
  );
}

apiProjectItemDeleteProjectItemDelete$Plain.PATH = '/api/ProjectItem/DeleteProjectItem';
